/**
 * Shared brokerage list surfaced on every fund detail page in the
 * "Where to Buy" section. Ported from the dane etf-website data layer.
 */
import type { Broker } from "./fund-detail-types";

export type { Broker };

export const SHARED_BROKERS: Broker[] = [
  { name: "Charles Schwab", url: "https://www.schwab.com", domain: "schwab.com" },
  { name: "Fidelity", url: "https://www.fidelity.com", domain: "fidelity.com" },
  { name: "E*Trade", url: "https://www.etrade.com", domain: "etrade.com" },
  {
    name: "Interactive Brokers",
    url: "https://www.interactivebrokers.com",
    domain: "interactivebrokers.com",
  },
  { name: "Robinhood", url: "https://www.robinhood.com", domain: "robinhood.com" },
  { name: "Webull", url: "https://www.webull.com", domain: "webull.com" },
  { name: "SoFi Invest", url: "https://www.sofi.com/invest/", domain: "sofi.com" },
  { name: "Public", url: "https://www.public.com", domain: "public.com" },
];
